import { useFeatureGate } from '@ctct/awesome-feature-flags';

export const useShouldDisplayModernPayflowForLegacyPlans = () => {
  // hooks list will be stable per env, so we can safely disable the hooks rule
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useFeatureGate({
    name: 'modern_payflow_for_legacy_plans',
    defaultValue: false,
  });
};
